import React, { useContext, useState } from "react";
import { ShowFrontEndContext } from "../types";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { pageDirContext } from "../../../App";


const MyLinkWithSearch: React.FC = () => {
  const { NosServicesRef, LegalRegTextRef, InstructionRef, ComplaintRef } =
    useContext(ShowFrontEndContext);
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation();
  
  const { pageDir } = useContext(pageDirContext)

  const scrollToLegalRegText = () => {
    LegalRegTextRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToNosServicesRef = () => {
    NosServicesRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToInstructionRef = () => {
    InstructionRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToComplaintRef = () => {
    ComplaintRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  
  return (
    <div
      className="space-y-4 md:space-y-0 flex flex-col md:flex-row gap-4 justify-center items-center"
      dir={pageDir}
    >
      {/* Links Section */}
      <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
        <LinkTag name={t("Nos Services")} scrollRef={scrollToNosServicesRef} />
        <LinkTag
          name={t("Textes Juridiques et Réglementaires")}
          scrollRef={scrollToLegalRegText}
        />
        <LinkTag
          name={t("Instructions de l'ONMDM")}
          scrollRef={scrollToInstructionRef}
        />
        <LinkTag
          name={t("Déposez Votre Plainte")}
          scrollRef={scrollToComplaintRef}
        />
      </div>

      {/* Search Input */}
      <div className="flex justify-center mt-4 w-full md:w-auto">
        <div className="relative w-full max-w-sm">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={t("Chercher....")}
            className={`text-gray-500 w-full py-2 ${
              pageDir === "rtl" ? "pl-4 pr-10 text-right" : "pl-10 pr-4 text-left"
            } rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-main transition-all duration-300`}
          />
          <FaSearch
            className={`absolute ${
              pageDir === "rtl" ? "right-3" : "left-3"
            } top-1/2 transform -translate-y-1/2 text-gray-500`}
          />
        </div>
      </div>
    </div>
  );
};

export default MyLinkWithSearch;


const LinkTag = ({ name, scrollRef }: { name: string; scrollRef: any }) => {
  
  return (
    <div
      onClick={scrollRef}
      className="underline text-sm text-gray-500 hover:text-gray-800 cursor-pointer transition-all duration-300 w-full md:w-auto"
    >
      {name}
    </div>
  );
};
